'use strict';

var novicell = novicell || {};
var Drupal = Drupal || {};
let sliderPlayers = [];
let YT;

novicell.scriptSpot = novicell.scriptSpot || new function (Drupal) {

   this.loadingIndicatorIframes = function() {
       const iframes = document.querySelectorAll('.script-spot iframe');
       if (iframes.length) {
           for (let i = 0; i < iframes.length; i++) {
               let iframe = iframes[i];
               /* Create loading div */
               let loading = document.createElement('div');
               loading.classList.add('iframe-loading-indicator');
               loading.classList.add('index-' + i);
               iframe.parentNode.insertBefore(loading, iframe);
               /* Start spinner */
               showSpinner('.iframe-loading-indicator.index-' + i);
               let spinner = loading.querySelector('.spinner-fading-circle');
               spinner.classList.add('spinner-fading-circle');
               spinner.classList.add('spinner-fading-circle--medium');
               spinner.classList.add('spinner-fading-circle--grey');
               spinner.classList.add('spinner-fading-circle--center');
               if (typeof Drupal.t === 'function') {
                   let loading_text = document.createElement('div');
                   loading_text.innerHTML = Drupal.t('Please wait');
                   loading.appendChild(loading_text);
               }
               /* Remove spinner when iframe is loaded */
               iframe.addEventListener('load', () => {
                   hideSpinner('.iframe-loading-indicator.index-' + i);
               });
           }
       }
   };
}(Drupal);